module.exports = __webpack_public_path__ + "img/item_sq.78159308.png";